export default __webpack_public_path__ + "static/media/unopnd_logo.a5a73c93.png";